<template>
    <div id="page-content-wrapper" class="admin-content-area">
        <template v-if="cantAccessPage === true">
            <div class="container-fluid xyz">
                <div class="page-header-top-container">
                    <div class="page-name color-71aa3f">
                        Contact Information
                    </div>
                    <button type="submit" class="btn general-button btn-primary" v-on:click.prevent="backShowTask">Back</button>
                </div>
                <div class="admin-page-content">
                    <div class="row">
                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                            <b-list-group>
                                <b-list-group-item>
                                    <div class="row">
                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                            <strong>Customer Name : </strong>
                                        </div>
                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                            <span class="">{{contactArr[0].cust_firstname}}</span>
                                        </div>
                                    </div>
                                </b-list-group-item>
                                <b-list-group-item>
                                    <div class="row">
                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                            <strong>Contact : </strong>
                                        </div>
                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                            <span class="">{{contactArr[0].first_name + contactArr[0].last_name}}</span>
                                        </div>
                                    </div>
                                </b-list-group-item>
                                <b-list-group-item>
                                    <div class="row">
                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                            <strong>Description : </strong>
                                        </div>
                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                            <span class="">{{contactArr[0].description}}</span>
                                        </div>
                                    </div>
                                </b-list-group-item>
                                <b-list-group-item>
                                    <div class="row">
                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                            <strong>Fax : </strong>
                                        </div>
                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                            <span class="">{{contactArr[0].fax}}</span>
                                        </div>
                                    </div>
                                </b-list-group-item>
                                <b-list-group-item>
                                    <div class="row">
                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                            <strong>Job Title : </strong>
                                        </div>
                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                            <span class="">{{contactArr[0].job_title}}</span>
                                        </div>
                                    </div>
                                </b-list-group-item>
                                <b-list-group-item>
                                    <div class="row">
                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                            <strong>Business Unit : </strong>
                                        </div>
                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                            <span class="">{{contactArr[0].bu_home}}</span>
                                        </div>
                                    </div>
                                </b-list-group-item>
                            </b-list-group>
                        </div>
                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                            <b-list-group>
                                <!-- <b-list-group-item>
                                    <div class="row">
                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                            <strong>Collector : </strong>
                                        </div>
                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                            <span class="">{{contactArr[0].user_firstname + " " + contactArr[0].user_lastname}}</span>
                                        </div>
                                    </div>
                                </b-list-group-item> -->
                                <template v-for="(contactDetailData , key) in contactDetailArr">
                                    <b-list-group-item>
                                        <div class="row">
                                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                <strong>Email Address : </strong>
                                            </div>
                                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                <span class="">{{contactDetailData.email_1}}</span>
                                            </div>
                                        </div>
                                    </b-list-group-item>
                                    <b-list-group-item>
                                        <div class="row">
                                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                <strong>Secondary Address : </strong>
                                            </div>
                                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                <span class="">{{contactDetailData.email_2}}</span>
                                            </div>
                                        </div>
                                    </b-list-group-item>
                                    <b-list-group-item>
                                        <div class="row">
                                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                <strong>Phone Number : </strong>
                                            </div>
                                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                <span class="">{{mobilenumber(mobilenumber(contactDetailData.phone_1,3,'-'),7,'-')}}</span>
                                            </div>
                                        </div>
                                    </b-list-group-item>
                                    <b-list-group-item>
                                        <div class="row">
                                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                <strong>Secondary Number : </strong>
                                            </div>
                                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                <span class="">{{mobilenumber(mobilenumber(contactDetailData.phone_2,3,'-'),7,'-')}}</span>
                                            </div>
                                        </div>
                                    </b-list-group-item>
                                </template>
                            </b-list-group>
                        </div>
                    </div>
                </div>
                <div class="page-header-top-container pt-0">
                    <div class="page-name color-71aa3f">
                        Address Information
                    </div>
                </div>
                <div class="admin-page-content">
                    <div class="row">
                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                            <b-list-group>
                                <template v-for="(contactAddressData , key) in contactAddressArr">
                                    <template v-if='isExcedeContact == true'>
                                        <b-list-group-item>
                                            <div class="row">
                                                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                    <h4 class="color-23727b">Primary Information</h4>
                                                </div>
                                            </div>
                                        </b-list-group-item>
                                    </template>
                                    <b-list-group-item>
                                        <div class="row">
                                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                <strong>Street : </strong>
                                            </div>
                                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                <span class="">{{contactAddressData.street}}</span>
                                            </div>
                                        </div>
                                    </b-list-group-item>
                                    <b-list-group-item>
                                        <div class="row">
                                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                <strong>Street2 : </strong>
                                            </div>
                                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                <span class="">{{contactAddressData.street2}}</span>
                                            </div>
                                        </div>
                                    </b-list-group-item>
                                    <b-list-group-item>
                                        <div class="row">
                                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                <strong>City : </strong>
                                            </div>
                                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                <span class="">{{contactAddressData.city}}</span>
                                            </div>
                                        </div>
                                    </b-list-group-item>
                                    <b-list-group-item>
                                        <div class="row">
                                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                <strong>State : </strong>
                                            </div>
                                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                <span class="">{{contactAddressData.state}}</span>
                                            </div>
                                        </div>
                                    </b-list-group-item>
                                    <b-list-group-item>
                                        <div class="row">
                                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                <strong>Postal Code : </strong>
                                            </div>
                                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                <span class="">{{contactAddressData.postal_code}}</span>
                                            </div>
                                        </div>
                                    </b-list-group-item>
                                    <b-list-group-item>
                                        <div class="row">
                                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                <strong>Country : </strong>
                                            </div>
                                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                <span class="">{{stringFormat(contactAddressData.country)}}</span>
                                            </div>
                                        </div>
                                    </b-list-group-item>
                                </template>
                            </b-list-group>
                        </div>
                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                            <b-list-group>
                                <template v-for="(contactAddressData , key) in contactAddressArr">
                                    <template v-if='isExcedeContact == true'>
                                        <b-list-group-item>
                                            <div class="row">
                                                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                    <h4 class="color-23727b">Secondary Information</h4>
                                                </div>
                                            </div>
                                        </b-list-group-item>
                                        <b-list-group-item>
                                            <div class="row">
                                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                    <strong>Street : </strong>
                                                </div>
                                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                    <span class="">{{contactAddressData.street_2}}</span>
                                                </div>
                                            </div>
                                        </b-list-group-item>
                                        <b-list-group-item>
                                            <div class="row">
                                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                    <strong>Street2 : </strong>
                                                </div>
                                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                    <span class="">{{contactAddressData.street2_2}}</span>
                                                </div>
                                            </div>
                                        </b-list-group-item>
                                        <b-list-group-item>
                                            <div class="row">
                                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                    <strong>City : </strong>
                                                </div>
                                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                    <span class="">{{contactAddressData.city_2}}</span>
                                                </div>
                                            </div>
                                        </b-list-group-item>
                                        <b-list-group-item>
                                            <div class="row">
                                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                    <strong>State : </strong>
                                                </div>
                                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                    <span class="">{{contactAddressData.state_2}}</span>
                                                </div>
                                            </div>
                                        </b-list-group-item>
                                        <b-list-group-item>
                                            <div class="row">
                                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                    <strong>Postal Code : </strong>
                                                </div>
                                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                    <span class="">{{contactAddressData.postal_code_2}}</span>
                                                </div>
                                            </div>
                                        </b-list-group-item>
                                        <b-list-group-item>
                                            <div class="row">
                                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                    <strong>Country : </strong>
                                                </div>
                                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                    <span class="">{{stringFormat(contactAddressData.country_2)}}</span>
                                                </div>
                                            </div>
                                        </b-list-group-item>
                                    </template>
                                </template>
                            </b-list-group>
                        </div>
                    </div>
                </div>
            </div>
            <!--<div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <div class="card">
                    <div class="header">
                        <h2>
                            Change Business Unit
                        </h2>
                    </div>
                    <div class="body">
                        <label for="assigned_to_business_id">Business Unit</label>
                        <v-select id="collector" v-model="assigned_to_business_id" @change="userChangedValue" name="assigned_to_business_id" label="text" :filterable="false" :options="businessArr" @search="onSearchUser" v-validate="'required'">
                            <template slot="no-options">
                                type to search Business Units...
                            </template>
                            <template slot="option" slot-scope="option">
                                <div class="d-center">
                                    {{ option.text }}
                                </div>
                            </template>
                            <template slot="selected-option" slot-scope="option">
                                <div class="selected d-center">
                                    {{ option.text }}
                                </div>
                            </template>
                        </v-select><br/>
                        <span v-show="errors.has('assigned_to_business_id')" class="help is-danger" v-if="errors.has('assigned_to_business_id')"><font color="red">Business Unit is Required</font></span>

                        <div class="row clearfix" >
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <div class="alert alert-success hide" id="alertSuccess">
                                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                    <strong>Business Unit Updated Successfully</strong>
                                </div>
                            </div>
                        </div>
                        <div class="row clearfix" >
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <div class="alert alert-warning hide" id="alertError">
                                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                    <strong id="errorMsg" class="error"></strong>
                                </div>
                            </div>
                        </div>
                        <template  v-for="(permission, index) in permissions">
                            <input v-if="permission.name == 'can_change_contact_settings'" id="addCaseBtn" type="submit" value="Update" class="btn general-button btn-success waves-effect pull-left" v-on:click.prevent="updateBusinessUnit()">
                        </template>
                        <div class="clearfix"></div>    
                    </div>
                    <div class="clearfix"></div>
                </div>
            </div>-->
        </template>
        <template v-else>
            <div class="admin-page-content">
                <div class="col-md-12 error-detail-main forms-container">
                    <div class="error-template">
                        <h1>Oops!</h1>
                        <h2>403</h2>
                        <div class="error-details">Sorry!, You don't have permission to access this page.</div>
                    </div>
                </div>
            </div>
        </template>

        <app-footer></app-footer>
    </div>   
</template>
<script>
    import Vue from 'vue';
    import FrontFooter from '@/components/partials/FrontFooter';
    import EventBus from '../event-bus';
    import SessioMixin from '../../mixins/sessionmixin';
    export default {
        name: 'ContactView',
        components: {
            'app-footer': FrontFooter,
        },
        mixins: [SessioMixin],
        data() {
            return{
                permissions: [],
                isExcedeContact: false,
                cantAccessPage: true,
                isLoggedIn: false,
                contactArr: [[]],
                contactAddressArr: [],
                contactDetailArr: [],
                // commentsArr:[],
                // comment: '',
                // editId: ''
                assigned_to_business_id: "",
                businessArr: []

            }
        },
        beforeMount: function () {
            var app = this;
            var check = window.localStorage.getItem('api_token');

            if (check != null) {
                this.isLoggedIn = true;
                app.getPermissions();
            }

        },
        mounted: function () {
            var self = this;
            var path = window.location.pathname;
            var segments = path.split("/");
            $(".removeActive").removeClass('active');
            if (segments[4] != 0) {
                $("#menucustomers").addClass("active");
            } else {
                $("#menucontacts").addClass('active');
            }
            //$("#menucontacts").addClass('active');
            if (localStorage.getItem("menu_small") == '1') {
                self.menuSmall();
            } else {
                self.menuBig();
            }
            self.showLoader();
            self.loadContact();
            var userObj = localStorage.getItem('user_obj');
            if (userObj != null) {
                var userJson = JSON.parse(userObj);
                EventBus.$emit("logged-in", false, userJson["first_name"], userJson["last_name"], userJson["email"]);
            }
        },
        methods: {
            getPermissions: function () {
                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/user/permission",
                    type: "POST",
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                        if (data.status == 'success') {
                            self.cantAccessPage = false;
                            self.permissions = data.content;
                            let current_build = window.localStorage.getItem("build_version");
                            let latest_build = data.build;
                            if (current_build != undefined && current_build == '') {
                                localStorage.setItem("build_version", data.build);
                            } else if (current_build != latest_build) {
                                localStorage.setItem("build_version", data.build);
                                location.reload(true);
                            }
                            if (self.permissions.length > 0) {
                                for (var i = 0; i < self.permissions.length; i++) {
                                    if (self.permissions[i].name == 'can_see_contact_view') {
                                        self.cantAccessPage = true;
                                    }
                                }
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.cantAccessPage = false;
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }

                });
            },
            loadContact() {
                var path = window.location.pathname;
                var segments = path.split("/");
                // console.log(segments[3]);
                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/contact/show/" + segments[3],
                    type: "GET",
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                        self.hideLoader();
                        // console.log(data);
                        self.contactArr = data.contact;
                        $.each(self.contactArr, function (i) {
                            if (self.contactArr[i].data_source == "excede") {
                                self.isExcedeContact = true;
                            }
                        });
                        self.contactAddressArr = data.contact_address;
                        self.contactDetailArr = data.contact_details;
                        self.assigned_to_business_id = {value: data.contact[0].assigned_to_business_id, text: data.contact[0].bu_home}
                        // console.log(self.contactAddressArr);
                        // console.log(self.contactArr);

                    },
                    error: function (jqXHR, exception) {
                        self.hideLoader();
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });

            },
            userChangedValue: function (value) {
                //console.log(value);
            },
            onSearchUser(search, loading) {
                if (search.length > 1) {
                    loading(true);
                    this.loadBusinessUnit(loading, search, this);
                }
            },
            loadBusinessUnit(loading, search, vm) {
                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/getbusinessunits",
                    type: "GET",
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    data: {
                        search: search
                    },
                    dataType: 'json',
                    success: function (data) {
                        loading(false);

                        self.businessArr = data;
                        //console.log(self.businessArr);
                    },
                    error: function (jqXHR, exception) {
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                })

            },
            backShowTask() {
                var self = this;
                var path = window.location.pathname;
                var segments = path.split("/");
                if (segments[4] != 0) {
                    self.$router.push("/customer/view/" + segments[4]);
                } else {
                    self.$router.push('/listcontacts');
                }
                // self.$router.push('/listcontacts');
            },
            updateBusinessUnit() {
                this.$validator.validate().then(result => {
                    if (result) {
                        var self = this;
                        var path = window.location.pathname;
                        var segments = path.split("/");
                        // console.log(self.assigned_to_business_id.value);
                        // console.log(segments[3]);
                        self.showLoader();

                        $.ajax({
                            url: process.env.ROOT_API + "/businessunit/update/" + segments[3],
                            type: "POST",
                            data: {assigned_to_business_id: self.assigned_to_business_id.value, id: segments[3]},
                            headers: {
                                'Accept': 'application/json',
                                "Access-Control-Allow-Origin": '*',
                                "Authorization": "Bearer " + localStorage.getItem("api_token"),
                                'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                                "Cache-Control": "no-cache"
                            },
                            dataType: 'json',
                            success: function (data) {
                                self.hideLoader();
                                //console.log(data);
                                $(".alert-success").toggleClass('show');
                                setTimeout(function () {
                                    $('.alert-success').removeClass('show');
                                    $('.alert-success').addClass('hide');
                                }, 5000);
                                if (data.status == 'success') {
                                    self.loadContact();
                                    //console.log(data.content);
                                } else {
                                    if (data.content.length > 0) {
                                        var err = "";
                                        for (var i = 0; i < data.content.length; i++) {
                                            err += data.content[i] + "<br>";
                                        }
                                        $("#errorMsg").html(err);
                                        $(".alert-warning").toggleClass('show');
                                        setTimeout(function () {
                                            $('.alert-warning').removeClass('show');
                                            $('.alert-warning').addClass('hide');
                                        }, 5000);
                                    }
                                }
                            },
                            error: function (jqXHR, exception) {
                                self.hideLoader();
                                if (jqXHR.status == 0) {
                                    self.error = "Remote server can not be reachable";
                                } else {
                                    //redirect to login page if user not authenticated
                                    if (jqXHR.status == 401) {
                                        //clear previous data
                                        localStorage.removeItem('user_obj');
                                        localStorage.removeItem('api_token');
                                        //EventBus.$emit("logged-in", true, "", "");
                                        self.$router.push("/login");
                                    }
                                    $("#errorMsg").html(jqXHR.responseJSON.message);
                                    $(".alert-warning").toggleClass('show');
                                    setTimeout(function () {
                                        $('.alert-warning').removeClass('show');
                                        $('.alert-warning').addClass('hide');
                                    }, 5000);
                                }
                            }
                        });
                    }
                });
            },
            mobilenumber(string, position, addstring) {
                if ($.trim(string) === "" && string.length <= 0) {
                    return string;
                } else {
                    return [string.slice(0, position), addstring, string.slice(position)].join('');
                }
            },
            stringFormat(string) {
                if (typeof (string) != 'undefined') {
                    return [string.toUpperCase()].join('');
                } else {
                    return false;
                }
            },
            menuSmall: function () {
                $('.opensidebar').show();
                $('.closesidebar').hide();
                $('.menu').addClass('menusmall');
                $('.sidemenu li a span,.legal').addClass('displaynone');
                $('.sidemenu li a i').addClass('displayicons');
                $('.sidebar').css({width: "70px"});
                $('.content').css({marginLeft: "70px"});
                $("html, body").animate({scrollTop: 0}, 10);
            },
            menuBig: function () {
                $('.opensidebar').hide();
                $('.closesidebar').show();
                $('.menu').removeClass('menusmall');
                $('.sidemenu li a span,.legal').removeClass('displaynone');
                $('.sidemenu li a i').removeClass('displayicons');
                $('.sidebar').css({width: "260px"});
                $('.content').css({marginLeft: "260px"});
                $("html, body").animate({scrollTop: 0}, 10);
            }
            // formatString(data){
            //     var self = this;
            //     var value = data.replace(/_/g," ");
            //     var upp = value.toLowerCase().replace(/\b[a-z]/g, function(letter) {
            //         return letter.toUpperCase();
            //     });
            //     return upp;
            // }

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/contact/ContactView.vue